export const START_PRODUCT_TOUR_PROMPT = 'START_PRODUCT_TOUR_PROMPT';
export const STOP_PRODUCT_TOUR_PROMPT = 'STOP_PRODUCT_TOUR_PROMPT';
export const TERMINATE_PROMPT = 'TERMINATE_PROMPT';
